export default "__VITE_ASSET__ahtGfL99__"